<template>
    <div>
        <b-modal id="deliveriesModal" size="xl" content-class="menu-bg-blue-transparent-modal del-modal" title="MMP Deliveries"
            hide-footer @show="getDeliveries()">
            <div class="form-check form-check-inline checkbox-group" v-for="(region, index) in regions" :key="index">
                <input class="form-check-input" type="checkbox" :id="'region-' + index" :value="region"
                    v-model="checkedNames" @change="handleCheckboxChange">
                <label class="form-check-label" :for="'region-' + index">{{ region }}</label>
            </div>
            <vue-bootstrap4-table :rows="deliveryRows" :columns="columns" :config="config" :actions="actions"
                :classes="classes" @downloadCSV="downloadCSV()">
            </vue-bootstrap4-table>
        </b-modal>
    </div>
</template>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import * as XLSX from 'xlsx'
import axios from 'axios'
export default {
    name: 'MMP_Deliveries',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            deliveryRows: [],
            rowData: [],
            regions: [],
            checkedNames: [],
            classes: {
                table: {
                    'menu-bg-blue-transparent': true,
                },
                tbody: {
                    'left-aligned-text': true
                }
            },
            columns: [
                {
                    label: 'Release ID',
                    name: 'release_id',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                },
                {
                    label: 'Part Number',
                    name: 'part_number',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                },
                {
                    label: 'Database',
                    name: 'database_name',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                },
                {
                    label: 'Delivery Type',
                    name: 'delivery_type',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                },
                {
                    label: 'Release Date',
                    name: 'release_date',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                },
                {
                    label: 'Last Updated',
                    name: 'updated_at',
                    sort: true,
                    column_text_alignment: 'text-left',
                    row_text_alignment: 'text-left'
                }
            ],
            config: {
                checkbox_rows: false,
                rows_selectable: true,
                card_mode: false,
                global_search: {
                    placeholder: 'Search...',
                    visibility: true,
                    showClearButton: true,
                    searchOnPressEnter: true
                },
                highlight_row_hover_color: 'rgba(6,60,109,0.04)',
                show_refresh_button: false,
                show_reset_button: false
            },
            actions: [
                {
                    btn_text: 'Download',
                    event_name: 'downloadCSV',
                    event_payload: {
                        msg: 'Download Deliveries CSV'
                    },
                    class: 'ml-4 btn btn-warning '
                }
            ],
        }
    },
    methods: {
        getDeliveries() {
            if (sessionStorage.token) {
                axios
                    .get(
                        process.env.API_LOCATION + '/api/release/deliveries',
                        {
                            headers: {
                                'x-auth-token': sessionStorage.token
                            }
                        }
                    )
                    .then(response => {
                        const content = response.data

                        if (content.errors) {
                            console.log(content.errors)
                        } else {
                            this.deliveryRows = content
                            this.rowData = content
                            const extents = content.map(p => p.extents);
                            this.regions = [...new Set(extents)];
                            this.checkedNames = this.regions
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            } else {
                console.log('No User Token')
            }
        },
        downloadCSV() {
            // The values array holds data in the same order as the above Promises
            try {
                let deliveries = XLSX.utils.json_to_sheet(this.deliveryRows)
                if (this.deliveryRows.length > 0 && deliveries) {
                    let wb = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(wb, deliveries, 'MMP Deliveries')
                    XLSX.writeFile(wb, `MMP_Deliveries.xlsx`)
                } else {
                    let errMsg = 'No Data Available.'
                    this.$bvToast.toast(errMsg, {
                        autoHideDelay: 10000,
                        title: 'Error Downloading CSV',
                        toaster: 'b-toaster-top-center'
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },
        handleCheckboxChange(event) {
            this.deliveryRows = this.rowData.filter(e => this.checkedNames.includes(e.extents))
        }
    }
}
</script>

<style>
.del-modal .menu-bg-blue-transparent,
.del-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.del-modal table { color: #063c6d !important; text-shadow: none !important; }
.del-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.del-modal thead th a,
.del-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.del-modal thead th input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
  font-size: 0.85rem;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}
.del-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.del-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.del-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.del-modal .footer-pagination-row td,
.del-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
.del-modal .form-check-label { color: #063c6d; }
.del-modal .form-check-input { accent-color: #063c6d; }
</style>

<style scoped>
.left-aligned-text {
    text-align: left !important;
}

.checkbox-group {
    margin: 0.5rem 0;
    transition: background-color 0.2s ease-in-out;
    border-radius: 8px;
    padding: 4px 18px;
}

.form-check-input {
    cursor: pointer;
}

.form-check-label {
    cursor: pointer;
    margin-left: 0.25rem;
}
</style>